import { Instance } from 'mobx-state-tree';
import { OrderUnschedulingWhileDeletingRouteDtoModelBase } from './OrderUnschedulingWhileDeletingRouteDtoModel.base';

/* The TypeScript type of an instance of OrderUnschedulingWhileDeletingRouteDtoModel */
export interface OrderUnschedulingWhileDeletingRouteDtoModelType extends Instance<typeof OrderUnschedulingWhileDeletingRouteDtoModel.Type> {}

/* A graphql query fragment builders for OrderUnschedulingWhileDeletingRouteDtoModel */
export {
  selectFromOrderUnschedulingWhileDeletingRouteDto, orderUnschedulingWhileDeletingRouteDtoModelPrimitives, OrderUnschedulingWhileDeletingRouteDtoModelSelector,
} from './OrderUnschedulingWhileDeletingRouteDtoModel.base';

/**
 * OrderUnschedulingWhileDeletingRouteDtoModel
 */
export const OrderUnschedulingWhileDeletingRouteDtoModel = OrderUnschedulingWhileDeletingRouteDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
